import React from 'react';
import NavBadge from './NavBadge';
import useDepartmentTasks from '../../hooks/useDepartmentTasks';
import useCurrentUser from '../../hooks/useCurrentUser';

// item 482 — the Department Tasks nav badge: how many OPEN tasks are assigned to me. A red count
// pill (iPhone-style); nothing when I have none assigned.
const TasksNavBadge: React.FC<{ collapsed?: boolean }> = ({ collapsed }) => {
  const { tasks } = useDepartmentTasks();
  const { user } = useCurrentUser();
  const myId = user?.id;
  if (!myId) return null;
  const mine = tasks.filter((t) => {
    if (t.isDone) return false;
    const ids = (t.assigneeUserIds ?? '').split(',').map((s) => s.trim());
    return ids.includes(myId);
  }).length;
  return <NavBadge count={mine} collapsed={collapsed} />;
};

TasksNavBadge.defaultProps = { collapsed: false };

export default TasksNavBadge;
